import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';

const tabs = [
  { path: '/admin/users', label: 'Usuarios' },
  { path: '/admin/tools', label: 'Herramientas' },
  { path: '/admin/roles', label: 'Roles' },
  { path: '/admin/logs', label: 'Logs de acceso' },
];

export default function AdminLayout() {
  const location = useLocation();

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-900 mb-4">Administración</h2>
      <div className="flex gap-1 mb-6 overflow-x-auto pb-1">
        {tabs.map(tab => {
          const active = location.pathname === tab.path;
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className="px-4 py-2 rounded-lg text-sm whitespace-nowrap transition-colors font-medium"
              style={active
                ? { backgroundColor: '#0f1117', color: '#ffffff' }
                : { backgroundColor: '#ffffff', color: '#6b7280' }
              }
            >
              {tab.label}
            </Link>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
}
